export const LIVE_REFRESH_MS = 15000;

export function compactParams(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== "" && value != null)
  );
}

export function isPortalUser(user) {
  return Array.isArray(user?.permissions) && user.permissions.includes("portal.sample.view");
}

export function saveDownload(data, filename, contentType) {
  const blob = data instanceof Blob ? data : new Blob([data], { type: contentType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function formatTat(value) {
  return value == null ? "—" : `${Number(value).toFixed(2)} days`;
}
